import TemplateView from '../../../TemplateView'
import ReportChartsStore from '../ReportChartsStore'
import messageResource from '../../../messageResource'

export default class CustomSettingsSection extends TemplateView {
    constructor($containerEl, printParameters, lightboxId, changesCallback) {
        super($containerEl)

        // these parameters are updated every time we update preview and saved only when we download pdf file
        this.printParameters = printParameters
        this.lightboxId = lightboxId //TODO: make this component markup independent from lightbox at some point
        this.changesCallback = changesCallback

        this.state = {
            fitToNPages: 1,
        }

        this.onStatePropertyChanged('fitToNPages', (fitToNPages) => {
            let label = ''
            switch (fitToNPages) {
                case 1:
                    label = messageResource.getMessage('report.chart_pdf_preview.fit_data_to_one_page')
                    break
                case 2:
                    label = messageResource.getMessage('report.chart_pdf_preview.fit_data_to_two_pages')
                    break
            }
            this.$fitDataCheckboxLabel.text(label)
        })
    }

    templateHtml() {
        return "<div class='dataLayoutSection'>" +
               "  <div class='parametersSectionHeader'><%=dataLayoutLabel%></div>" +
               "  <div class='chartSizeParameter'>" +
               "    <div class='selectorLabel'><%=chartSizeLabel%></div>" +
               "    <div id='<%=id%>_chartSizeSelector'></div>" +
               "    <div class='selectorLabel'><%=barsLabel%></div>" +
               "  </div>" +
               "  <div>" +
               "    <table>" +
               "      <tr>" +
               "        <td><input type='checkbox' id='<%=id%>_showListOfDataValues'/></td>" +
               "        <td><label for='<%=id%>_showListOfDataValues'><%=showDataValuesLabel%></label></td>" +
               "      </tr>" +
               "      <tr class='percentCheckboxTr'>" +
               "        <td><input type='checkbox' id='<%=id%>_showListOfPercentValues'/></td>" +
               "        <td><label for='<%=id%>_showListOfPercentValues'><%=showPercentValuesLabel%></label></td>" +
               "      </tr>" +
               "      <tr class='fitDataCheckboxTr'>" +
               "        <td><input type='checkbox' id='<%=id%>_fitDataToOnePage'/></td>" +
               "        <td><label for='<%=id%>_fitDataToOnePage'></label></td>" +
               "      </tr>" +
               "    </table>" +
               "  </div>" +
               "</div>"
    }

    templateModel() {
        return {id: this.lightboxId}
    }

    messageKeys() {
        return {
            "dataLayoutLabel": "report.chart_pdf_preview.data_layout",
            "chartSizeLabel": "report.chart_pdf_preview.chart_size",
            "barsLabel": "report.chart_pdf_preview.bars",
            "showDataValuesLabel": "report.chart_pdf_preview.show_data_values_list",
            "showPercentValuesLabel": "report.chart_pdf_preview.show_percent_values_list",
        }
    }

    afterRender() {
        this.fitDataToOnePageCheckbox = this.initFitDataCheckBox()
        // chart size selector is reinitialized every time we switch lightbox to PDF Preview View if chart type is not PIE_CHART, so we do not initialize it here
        this.chartSizeSelectorContainer = document.getElementById(this.lightboxId + "_chartSizeSelector")

        this.initShowValuesCheckboxes()
        this.lastSavedShowListOfPercentValues = ReportChartsStore.getPrintParametersForSave().showListOfPercentValues

        this.$fitDataCheckboxLabel = this.find('.fitDataCheckboxTr label')

        this.renderInitialState()
    }

    update() {
        const printParameters = ReportChartsStore.getPrintParametersForSave()
        this.fitDataToOnePageCheckbox.checked = printParameters.fitDataToOnePage
        this.showListOfDataValuesCheckbox.checked = printParameters.showListOfDataValues
        this.showListOfPercentValuesCheckbox.checked = printParameters.showListOfPercentValues
    }

    initFitDataCheckBox() {
        const checkBox = document.getElementById(this.lightboxId + "_fitDataToOnePage")
        checkBox.onchange = this.changesCallback
        return checkBox
    }

    initShowValuesCheckboxes() {
        this.showListOfDataValuesCheckbox = document.getElementById(this.lightboxId + "_showListOfDataValues")
        this.showListOfDataValuesCheckbox.onchange = this.changesCallback

        this.showListOfPercentValuesCheckbox = document.getElementById(this.lightboxId + "_showListOfPercentValues")
        this.showListOfPercentValuesCheckbox.onchange = this.changesCallback
        this.showListOfPercentValuesCheckboxIsVisible = true
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfSettingsPreview/CustomSettingsSection.js